/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { setPaginationIndex } from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';

import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import { monthMapping } from '../../../../SharedModules/utilities/utilities';
import { getTableHeads } from './TableHead';
import { exportAllPDF } from './exportAll';

const DisplayRider = () => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const {
    isLoading,
    rebateProgramList,
    displayObj: {
      rebateProgram: rebateProgramValue,
      fromDateValue,
      searchResult,
      isAllRebateProgram,
      riderNumber,
      countValue,
      rebateProgrameName,
    },
  } = useSelector((state) => state?.sharedState?.RiderReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;

  const [rows, setRows] = React.useState([]);

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [reportData, setReportData] = React.useState({});
  const [count, setCount] = React.useState(countValue);
  const [paginationArray, setPaginationArray] = React.useState([]);
  const [columnApi, setColumnApi] = React.useState(null);

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  // Function handle the next previous button actions on click
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }
    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }
    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // Function handle the next previous button actions on blur
  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      await Promise.resolve();
      // setTimeout(() => {
        value < 1
          ? dispatch(setPaginationIndex(1))
          : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  // Interest override api call at initial load
  React.useEffect(() => {
    let beginDate = quarterToDate(fromDateValue);

    if (beginDate.includes('/')) {
      const splittedBD = beginDate.split('/');
      beginDate = `${splittedBD[0]}-${monthMapping[splittedBD[0]]}-${
        splittedBD[2]
      }`;
    }
  }, []);
  const groupBy = function (xs, key) {
    return xs?.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  // Set the table data rows
  React.useEffect(() => {
    const data = searchResult;
    let paginationLength = 1;
    let groupedData = {};
    const reportByIndividualRpcData = groupBy(
      searchResult.reportByIndividualRpc,
      'rebateProgramCode'
    );
    groupedData = {
      ...reportByIndividualRpcData,
    };
    if (isAllRebateProgram) {
      groupedData = {
        'Summary By Calender Year': searchResult.reportByYear,
        'Summary By Program': searchResult.reportByAllRpc,
        ...groupedData,
      };
      paginationLength = Object.keys(groupedData).length;
    }

    setPaginationArray([...Array(paginationLength).keys()]);

    setReportData(groupedData);
  }, [searchResult]);

  React.useEffect(() => {
    let keys = Object.keys(reportData);
    keys.sort();

    if (isAllRebateProgram) {
      keys = keys.filter(
        (key) =>
          ['Summary By Calender Year', 'Summary By Program'].indexOf(key) == -1
      );
      keys = ['Summary By Calender Year', 'Summary By Program', ...keys];
    }

    reportData[keys[count - 1]]
      ? setRows(reportData[keys[count - 1]])
      : setRows([]);
  }, [count, reportData]);

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  /*
     Below threee functions are for calculating data of table bottom pinned row
   */
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rows;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        original: sum('original'),
        pricingAdjSinceBilling: sum('pricingAdjSinceBilling'),
        utilizationAdjSinceBilling: sum('utilizationAdjSinceBilling'),
        otherAdjustments: sum('otherAdjustments'),
        currentValueOfInvoices: sum('currentValueOfInvoices'),
        priorCollcollectionsPriorCurrentSFY: sum(
          'priorCollcollectionsPriorCurrentSFY'
        ),
        totalPrincipalCollected: sum('totalPrincipalCollected'),
        totalInterestCollected: sum('totalInterestCollected'),
        totalCollections: sum('totalCollections'),
        princOutstandingPrincipal: sum('princOutstandingPrincipal'),
        interestOutstandingInterest: sum('interestOutstandingInterest'),
        collectionRatesForPrincipal: '',
        year: 'Total:',
        rebateProgram: 'Total:',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const addPinnedRowData = () => {
    const exportAllDataObj = {};
    for (const key in reportData) {
      const data = JSON.parse(JSON.stringify(reportData[key]));
      const pinnedRow = {
        isBottomRow: true,
        year: 'Total',
        rebateProgramCode: 'Total',
        original: 0,
        pricingAdjSinceBilling: 0,
        utilizationAdjSinceBilling: 0,
        otherAdjustments: 0,
        currentValueOfInvoices: 0,
        priorCollcollectionsPriorCurrentSFY: 0,
        totalPrincipalCollected: 0,
        totalInterestCollected: 0,
        totalCollections: 0,
        princOutstandingPrincipal: 0,
        interestOutstandingInterest: 0,
        bold: true,
      };
      for (let i = 0; i < data.length; i += 1) {
        pinnedRow.original += data[i].original;
        pinnedRow.pricingAdjSinceBilling += data[i].pricingAdjSinceBilling;
        pinnedRow.utilizationAdjSinceBilling +=
          data[i].utilizationAdjSinceBilling;
        pinnedRow.otherAdjustments += data[i].otherAdjustments;
        pinnedRow.currentValueOfInvoices += data[i].currentValueOfInvoices;
        pinnedRow.priorCollcollectionsPriorCurrentSFY +=
          data[i].priorCollcollectionsPriorCurrentSFY;
        pinnedRow.totalPrincipalCollected += data[i].totalPrincipalCollected;
        pinnedRow.totalInterestCollected += data[i].totalInterestCollected;
        pinnedRow.totalCollections += data[i].totalCollections;
        pinnedRow.princOutstandingPrincipal +=
          data[i].princOutstandingPrincipal;
        pinnedRow.interestOutstandingInterest +=
          data[i].interestOutstandingInterest;
      }
      data.push(pinnedRow);
      exportAllDataObj[key] = data;
    }

    return exportAllDataObj;
  };
  const exportAllToPDF = (name) => {
    const header = {
      reportName: 'Texas Vendor Drug Program',
      fileName: name,
    };
    const paginationArr = Object.keys(reportData);
    const allCols = getTableHeads(['Year'], fromDateValue);
    const cols = [];
    /* istanbul ignore else */
    if (allCols[0].children) {
      for (let i = 0; i < allCols.length; i += 1) {
        for (let j = 0; j < allCols[i].children.length; j += 1) {
          cols.push(allCols[i].children[j]);
        }
      }
    }
    const widths = cols.map((item, i) =>
      i === 0 && item.headerName === ' ' ? 60 : '*'
    );
    const pageHeading = 'Appendix';
    const allData = addPinnedRowData();
    exportAllPDF(
      header,
      allData,
      allCols,
      userDefaults,
      {
        pageSize: {
          width: 1450,
          height: 700,
        },
        info: {
          thirdInfo: 'Health and  Human Services Commission',
          fourthInfo: `As Of Date: ${fromDateValue}`,
        },
      },
      paginationArr,
      pageHeading,
      widths,
      logInUser
    );
  };
  const keys = Object.keys(reportData);
  // Below 4 variable for PDF header slected information
  const boldStyle = {
    fontWeight: 700,
    fontSize: 12,
    color: '#274463',
  };
  const firstInfo = ' ';
  const secondInfo =
    (isAllRebateProgram && count > 2) || (!isAllRebateProgram && count == 1)
      ? `Appendix A${count > 3 ? 3 : count}: ${
          !isAllRebateProgram && count == 1
            ? rebateProgramNameValue
            : keys[count - 1]
        }`
      : isAllRebateProgram && (count == 1 || count == 2)
      ? `Appendix A${count}: ${
          count === 1 ? 'Summary By Calender Year' : 'Summary By Program'
        }`
      : '';

  const thirdInfo = 'Health and  Human Services Commission';
  const sixthInfo = '';
  const fourthInfo = `As Of Date: ${fromDateValue} `;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="State Reports" parent2="Rider Display" />

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 ">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    {isAllRebateProgram && (count == 1 || count == 2) && (
                      <div className="row mb-2">
                        <div className="col-7">
                          <span style={{ marginLeft: -15 }}>
                            <b style={boldStyle}>Rider: </b>
                            {`Performance Report: ${
                              riderNumber.length ? `${riderNumber} - ` : ''
                            }Prescription Drug Rebate Program`}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      {((isAllRebateProgram && count > 2) ||
                        (!isAllRebateProgram && count == 1)) && (
                        <div className="col-6">
                          <TextField
                            label="Rebate Program: "
                            id="Rebate Program"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled
                            value={
                              !isAllRebateProgram && count == 1
                                ? rebateProgramNameValue
                                : keys[count - 1]
                            }
                          />
                        </div>
                      )}
                      {!isAllRebateProgram && count == 1 && (
                        <div className="col-12 mt-2">
                          <span style={boldStyle}>
                            <b style={boldStyle}> Appendix A1: </b>
                            {rebateProgramNameValue}
                          </span>
                        </div>
                      )}
                      {isAllRebateProgram && count == 1 && (
                        <span style={boldStyle}>
                          <b style={boldStyle}>Appendix A1:</b> Summary by
                          Calendar Year
                        </span>
                      )}
                      {isAllRebateProgram && count == 2 && (
                        <span style={boldStyle}>
                          <b style={boldStyle}>Appendix A2:</b> Summary By
                          Program
                        </span>
                      )}
                      {isAllRebateProgram && count > 2 && (
                        <div className="col-12 mt-2">
                          <span style={boldStyle}>
                            <b style={boldStyle}>Appendix A3:</b>{' '}
                            {keys[count - 1]}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <div
              id="testGrid"
              className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
            >
              <TableGridWithFeatures
                gridHeight={fullScreenView ? '100vh' : 350}
                gridCall={onGridReady}
                columnDefs={
                  count === 2
                    ? getTableHeads(['Rebate Program'], fromDateValue)
                    : getTableHeads(['Year'], fromDateValue)
                }
                data-testid="display-rider-grid"
                rowSelection="single"
                onFilterData={onFilterChanged}
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                rowData={rows?.map((item) => {
                  return {
                    ...item,
                    original: item.original ? item.original : '0.00',
                    pricingAdjSinceBilling: item.pricingAdjSinceBilling
                      ? item.pricingAdjSinceBilling
                      : '0.00',
                    utilizationAdjSinceBilling: item.utilizationAdjSinceBilling
                      ? item.utilizationAdjSinceBilling
                      : '0.00',
                    otherAdjustments: item.otherAdjustments
                      ? item.otherAdjustments
                      : '0.00',
                    currentValueOfInvoices: item.currentValueOfInvoices
                      ? item.currentValueOfInvoices
                      : '0.00',
                    priorCollcollectionsPriorCurrentSFY:
                      item.priorCollcollectionsPriorCurrentSFY
                        ? item.priorCollcollectionsPriorCurrentSFY
                        : '0.00',
                    totalPrincipalCollected: item.totalPrincipalCollected
                      ? item.totalPrincipalCollected
                      : '0.00',
                    totalInterestCollected: item.totalInterestCollected
                      ? item.totalInterestCollected
                      : '0.00',
                    totalCollections: item.totalCollections
                      ? item.totalCollections
                      : '0.00',
                    princOutstandingPrincipal: item.princOutstandingPrincipal
                      ? item.princOutstandingPrincipal
                      : '0.00',
                    interestOutstandingInterest:
                      item.interestOutstandingInterest
                        ? item.interestOutstandingInterest
                        : '0.00',
                    collectionRatesForPrincipal:
                      item.collectionRatesForPrincipal
                        ? item.collectionRatesForPrincipal
                        : '0.00',
                  };
                })}
                exportFile
                animateRows
                isScrollOn
                defaultColWidth={230}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                countValue={count}
                sideBar={false}
                reportName="Rider Report"
                fileName="Rider Report"
                // singleClickEdit
                enterMovesDown
                suppressCellFocus
                exportAllTpPDF={isAllRebateProgram ? exportAllToPDF : null}
                // customPDFExport={exportAllToPDF}
                // onCellFocused={onCellFocused}
                handleFullScreenViewClick={changeFullScreenView}
                pinnedBottomRowData={pinnedBottomRowData}
                info={{
                  firstInfo,
                  secondInfo,
                  thirdInfo,
                  fourthInfo,
                  sixthInfo,
                }}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (cellInfo?.data?.isBottomRow) {
                      return <div className="semiBoldText">{name}</div>;
                    }
                    return <div>{name}</div>;
                  },
                }}
                getFilterApply={getFilterApply}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayRider;
